import { createContext } from "react";
import type { ChatBoxListState } from "../../core/controllers/chat-box-list-ui-controller";
import { IChatBoxListUIController } from "../../core/controllers";

export const ChatBoxListStateContext = createContext<ChatBoxListState>({} as ChatBoxListState);

export const ChatBoxListUIControllerContext = createContext<IChatBoxListUIController>(
	{} as IChatBoxListUIController,
);

interface ChatBoxListProviderProps {
	controller: IChatBoxListUIController;
	children?:
		| React.ReactNode
		| ((state: ChatBoxListState, controller: IChatBoxListUIController) => React.ReactNode);
}

export const ChatBoxListProvider = (props: ChatBoxListProviderProps) => {
	props.controller.bindUIView();
	//WTF: React???
	// useEffect(() => {
	// 	return () => {
	// 		props.controller.dispose();
	// 	};
	// }, [controller]);

	return (
		<ChatBoxListStateContext.Provider value={props.controller.state}>
			<ChatBoxListUIControllerContext.Provider value={props.controller}>
				{typeof props.children === "function"
					? props.children(props.controller.state, props.controller)
					: props.children}
			</ChatBoxListUIControllerContext.Provider>
		</ChatBoxListStateContext.Provider>
	);
};
